import { Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { TaxService } from 'src/app/services/management/tax.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { firstValueFrom, Subscription } from 'rxjs';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { HttpEventType } from '@angular/common/http';
import { TaxImportModel } from 'src/app/models/imports/tax-import.model';
import readXlsxFile from 'read-excel-file';

@Component({
  selector: 'app-import-tax',
  templateUrl: './import-tax.component.html',
  styleUrl: './import-tax.component.scss',
  standalone: false
})
export class ImportTaxComponent {

  private readonly taxService = inject(TaxService);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly ref = inject(DynamicDialogRef, { optional: true });

  taxAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  taxImport: boolean = false;
  eventFile: any;
  errorTax: number = 0;
  loadTaxModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = '';
  suscription: Subscription;
  visibleTxt: boolean = false;

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  attachFileImport() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  close() {
    const data: ModalObjectType = {};
    if (this.taxImport) {
      data.params = { reload: true };
      this.ref?.close(data);
    } else {
      data.params = { reload: false };
      this.ref?.close(data);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  downloadGuideImport() {
    this.taxService.downloadGuideImport().subscribe(data => {
      if (data.type === HttpEventType.Response) {
        const downloadedFile = new Blob([data.body!], { type: data.body!.type });
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        a.download = "GuiaImpuestos.docx";
        a.href = URL.createObjectURL(downloadedFile);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      }
    });
  }

  downloadErrorsTxt() {
    if (!this.taxAlerts || this.taxAlerts.length === 0) {
      this.toastHandlerService.showToast(
        'error',
        'No hay alertas para exportar'
      );
      return;
    }

    this.taxService.exportImportErrors(this.taxAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];
        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionImpuestos_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast(
          'error',
          'Error al exportar el archivo'
        );
      }
    });
  }

  importTaxes() {
    this.taxAlerts = [];
    this.errorTax = 0;
    this.visibleTxt = false;
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<TaxImportModel>();
    let row: TaxImportModel;
    let counter: number = 1;

    let taxTypeCode: string, code: string, alterCode: string, alterCode2: string, name: string,
      rate: number, minimumBase: number, saleAccount: string, saleDevolutionAccount: string,
      purchaseAccount: string, purchaseDevolutionAccount: string, payAccountSelfWithholdingFuente: string,
      devolutionAccountSelfWithholdingFuente: string, departmentCode: string, cityCode: string;

    if (!input.files[0]) {
      this.toastHandlerService.showToast(
        'error',
        'No ha seleccionado ningún archivo.'
      );
      return;
    }

    readXlsxFile(input.files[0]).then(async (rows) => {
      if (rows.length <= 1) {
        this.toastHandlerService.showToast(
          'error',
          'El archivo ingresado no tiene registros para importar.'
        );
        return;
      }

      rows.splice(0, 1);
      rows.forEach(element => {
        counter++;
        let rowHasError = false;

        // A. Código Tipo Impuesto
        taxTypeCode = element[0] as string;
        if (!taxTypeCode) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código del tipo de impuesto no es válido.`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        } else if (taxTypeCode.length > 6) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna A. El código del tipo de impuesto supera el máximo de caracteres (6).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // B. Código
        code = element[1] as string;
        if (!code) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código no es válido.`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        } else if (code.length > 6) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna B. El código supera el máximo de caracteres (6).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // C. Código Alterno
        alterCode = element[2] as string;
        if (alterCode != null && alterCode.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna C. El código alterno supera el máximo de caracteres (10).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // D. Código Alterno 2
        alterCode2 = element[3] as string;
        if (alterCode2 != null && alterCode2.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna D. El código alterno 2 supera el máximo de caracteres (10).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // E. Nombre
        name = element[4] as string;
        if (name == null) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El nombre no es válido.`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        } else if (name.length > 70) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna E. El nombre supera el máximo de caracteres (70).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // F. Tarifa
        rate = parseFloat(element[5] as string);
        if (isNaN(rate)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna F. La tasa no es válida.`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // G. Base Mínima
        minimumBase = parseFloat(element[6] as string);
        if (isNaN(minimumBase)) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna G. La base mínima no es válida.`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // H. Cuenta Venta
        saleAccount = element[7] as string;
        if (saleAccount != null && saleAccount.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna H. La cuenta de venta supera el máximo de caracteres (10).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // I. Cuenta Devolución Venta
        saleDevolutionAccount = element[8] as string;
        if (saleDevolutionAccount != null && saleDevolutionAccount.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna I. La cuenta de devolución venta supera el máximo de caracteres (10).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // J. Cuenta Compra
        purchaseAccount = element[9] as string;
        if (purchaseAccount != null && purchaseAccount.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna J. La cuenta de compra supera el máximo de caracteres (10).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // K. Cuenta Devolución Compra
        purchaseDevolutionAccount = element[10] as string;
        if (purchaseDevolutionAccount != null && purchaseDevolutionAccount.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna K. La cuenta de devolución compra supera el máximo de caracteres (10).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // L. Cuenta Pago Autoretencion Fuente
        payAccountSelfWithholdingFuente = element[11] as string;
        if (payAccountSelfWithholdingFuente != null && payAccountSelfWithholdingFuente?.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna L. La cuenta de pago autoretención fuente supera el máximo de caracteres (10).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // M. Cuenta Devolución Autoretencion Fuente
        devolutionAccountSelfWithholdingFuente = element[12] as string;
        if (devolutionAccountSelfWithholdingFuente != null && devolutionAccountSelfWithholdingFuente.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna M. La cuenta de devolución autoretención fuente supera el máximo de caracteres (10).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // N. Código Ciudad
        cityCode = element[13] as string;
        if (cityCode != null && cityCode.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna N. El código de ciudad supera el máximo de caracteres (10).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        // O. Código Departamento
        departmentCode = element[14] as string;
        if (departmentCode != null && departmentCode?.length > 10) {
          const alert = new PreInvoicingAlertModel();
          alert.alertType = 1;
          alert.message = `Fila ${counter}, Columna O. El código de departamento supera el máximo de caracteres (10).`;
          this.taxAlerts.push(alert);
          rowHasError = true;
        }

        if (!rowHasError) {
          row = new TaxImportModel(
            counter, taxTypeCode, code, alterCode, alterCode2, name, rate, minimumBase,
            saleAccount, saleDevolutionAccount, purchaseAccount, purchaseDevolutionAccount,
            payAccountSelfWithholdingFuente, devolutionAccountSelfWithholdingFuente,
            departmentCode, cityCode
          );
          rowsImports.push(row);
        } else {
          isOk = false;
        }

      });

      if (isOk && rowsImports.length > 0) {
        try {
          const response = await firstValueFrom(this.taxService.importTaxes(rowsImports));
          this.loadTaxModel = response;
          this.taxAlerts = response?.alerts ?? [];
          this.errorTax = response?.preInvoicingStateId;
          if (this.errorTax === 1) {
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea.',
              'ERROR'
            );
          } else if (this.taxAlerts.length > 0) {
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con alertas, puede exportarlas si lo desea'
            );
          } else {
            this.visibleTxt = false;
            this.taxImport = true;
            this.toastHandlerService.showToast(
              'success',
              'La importación terminó exitosamente.'
            );
            this.close();
          }
          this.clearInputFile();
        } catch (error) {
          this.nameFile = 'Ningún archivo seleccionado.';
          console.error('Error al importar impuestos.', error);
        }
      } else {
        this.errorTax = 1;
        this.visibleTxt = true;
        this.toastHandlerService.showToast(
          'error',
          'La importación terminó con errores, puede exportarlos si lo desea'
        );
      }
    });
  }
}
